import {  createSlice } from '@reduxjs/toolkit';
import { ProductDetail, ProductModel} from '../models/productServiceModels'


const initialState:ProductModel = {
    productDetail:new ProductModel().productDetail
}

const productDetailSlice = createSlice({
    name:'productDetail',
    initialState,
    reducers:{
        setProductDetail(state,action:{payload:ProductDetail}){
            state.productDetail = action.payload;
        }
    }
});

export const {
    setProductDetail,
} = productDetailSlice.actions;

export default productDetailSlice.reducer;